module.exports = __webpack_public_path__ + "img/button2.b39a51ca.png";